var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.96875H13.1578C13.0047 2.96875 12.8594 3.03906 12.7656 3.15937L6.32344 11.3203L3.23438 7.40625C3.18765 7.34692 3.12808 7.29895 3.06016 7.26593C2.99223 7.23292 2.91771 7.21572 2.84219 7.21562H1.75C1.64531 7.21562 1.5875 7.33594 1.65156 7.41719L5.93125 12.8391C6.13125 13.0922 6.51563 13.0922 6.71719 12.8391L14.3484 3.16875C14.4125 3.08906 14.3547 2.96875 14.25 2.96875Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.20b77640.svg";
export { ForwardRef as ReactComponent };